import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import "./Users.css";
import Loader from "../common/loader/Loader";
import { toast } from "react-toastify";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function Users(props) {
  const [agents, setAgents] = useState();
  const [books, setBooks] = useState([]);
  const [record, setRecord] = useState();
  const [language, setLanguage] = useState();
  const [redirect, setRedirect] = useState(null);
  const [showInfo, setshowInfo] = useState(true);
  const [renderShowsTotal, setrenderShowsTotal] = useState(true);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [value, setValue] = React.useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [userProfiles, setUserProfiles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [languages, setLanguages] = useState([]);

  let history = useHistory();
  const useStyles = makeStyles({
    root: {
      width: "100%",
      overflowX: "auto",
    },
    table: {
      minWidth: 650,
    },
    tableHead: {
      background: "#3f51b5",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "darkcyan !important",
      },
    },
    tableRow: {
      "&:hover": {
        backgroundColor: "lightgrey !important",
      },
    },
    headerCell: {
      color: "white",
    },
  });

  const classes = useStyles();

  useEffect(() => {
    LoadUser();
  }, []);

  const LoadUser = () => {
    setIsLoading(true);
    const url = process.env.REACT_APP_API2_URL + "/User/GetUsers";

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setRecord(data[0]);
        setAgents(data);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    const url = process.env.REACT_APP_API2_URL + "/Player/GetBooks";

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let bookInfoInfo = data.map((v) => {
          v.value = v.idBook;
          v.text = v.description;
          return v;
        });
        setBooks(bookInfoInfo);
      });
  }, []);

  // Load User Profiles, Departments, and Languages
  useEffect(() => {
    // User Profiles
    axios
      .get(process.env.REACT_APP_API2_URL + "/User/UserProfile_GetList")
      .then((response) => {
        const profiles = response.data.map((profile) => ({
          value: profile.idUserProfile,
          text: profile.profileName,
        }));
        setUserProfiles(profiles);
      })
      .catch((error) => console.error("Error fetching user profiles:", error));

    // Departments
    axios
      .get(process.env.REACT_APP_API2_URL + "/User/Department_GetList")
      .then((response) => {
        const departments = response.data.map((dept) => ({
          value: dept.idDepartment,
          text: dept.description,
        }));
        setDepartments(departments);
      })
      .catch((error) => console.error("Error fetching departments:", error));

    // Languages
    axios
      .get(
        `${process.env.REACT_APP_API2_URL}/User/UsersLanguage_GetLanguageList?idUser=${userInfo.userId}`
      )
      .then((response) => {
        const langs = response.data.map((lang) => ({
          value: lang.idLanguage,
          text: lang.langDesc,
        }));
        setLanguages(langs);
      })
      .catch((error) => console.error("Error fetching languages:", error));
  }, [userInfo.userId]);

  function onAfterInsertRow(row) {
    console.log("Row values before insert:", row);  // Depuración para verificar los valores en row
    let RequestDTO = {
      IdUserProfile: row.idUserProfile || "",
      IdDepartment: row.idDepartment || "",
      ModifiedUser: userInfo.userId,
      LoginName: row.loginName || "",
      Name: row.name || "",
      Password: row.password || "",
      Status: true,
      IdLanguage: row.idLanguage || "",
    };

    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/User/InsertUser",
      data: RequestDTO,
    }).then((response) => {
      if (response.data === -1) {
        toast.error("Error user already exist!");
      } else if (response.data > 0) {
        toast.success("User created");
      }
      LoadUser();
    });
  }

  function onAfterDeleteRow(rowKeys) {
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/User/PlayerUser_Delete?idUser=" +
        rowKeys +
        "&idUser=" +
        userInfo.userId,
    }).then((response) => {
      console.log("response", response);
    });
    alert("The rowkey you dropped: " + rowKeys);
  }

  function customConfirm(next, dropRowKeys) {
    const dropRowKeysStr = dropRowKeys.join(",");
    if (
      window.confirm(
        `(It's a custom confirm)Are you sure you want to delete ${dropRowKeysStr}?`
      )
    ) {
      next(); // Si la confirmación es true, continúa con la eliminación
    }
  }

  function selectedValues(row) {
    console.log(`You click row id Users: ${row.idUser}`);
    setRedirect(row);
  }

  const options = {
    page: 1,
    sizePerPageList: [
      { text: "15", value: 15 },
      { text: "50", value: 50 },
      { text: "500", value: 500 },
      { text: "1000", value: 1000 },
    ],
    sizePerPage: 10,
    pageStartIndex: 1,
    paginationSize: 3,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    paginationShowsTotal: renderShowsTotal,
    paginationPosition: "bottom",
    afterDeleteRow: onAfterDeleteRow,
    handleConfirmDeleteRow: customConfirm,
    onRowClick: selectedValues,
    afterInsertRow: onAfterInsertRow, // Sigue siendo parte del flujo
    insertFailIndicator: "Error during insert"
  };

  const selectRowProp = {
    mode: "checkbox",
    clickToSelect: false,
  };

  const toggleTable = () => {
    setshowInfo(!showInfo);
  };

  if (redirect) {
    let pushURL = "/user/" + redirect.idUser;
    return <div>{history.push(pushURL)}</div>;
  }

  // Editor personalizado para los campos de inserción
  // react-bootstrap-table calls getElement(column, attr, className, ignoreEditable, defaultValue).
  // `attr` carries the string ref the library needs to read the field's value on Save
  // (InsertModalBody.getFieldValue reads this.refs[field+i].value), so it must be spread
  // onto the actual <select> or the library crashes with "Cannot read properties of
  // undefined (reading 'value')" when Save is clicked.
  const customInsertEditor = (column, attr, className, ignoreEditable, defaultValue, options) => {
    return (
      <select
        {...attr}
        className={className || "form-control"}
        defaultValue={defaultValue || ""}
      >
        <option value="">Select</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.text}
          </option>
        ))}
      </select>
    );
  };

  // Revisamos los datos que se pasan en el modal
  const InsertModalBody = (props) => {
    console.log("Modal data:", props);  // Verificamos qué valores están pasando
    return (
      <div>
        {/* Mostrar los inputs aquí */}
      </div>
    );
  };

  return (
    <div id="main-div">
      <Paper className={classes.root}>
        <br />
        <br /> <h2>Users</h2>
        {isLoading ? <Loader /> : ""}
        <Table className={classes.table} aria-label="simple table">
          <TableBody className={showInfo ? "show-table" : "hide-table"}>
            {agents && (
              <div>
                <BootstrapTable
                  pagination={true}
                  options={options}
                  selectRow={selectRowProp}
                  insertRow={true}
                  version="4"
                  data={agents}
                  deleteRow={true}
                  hover
                >
                  <TableHeaderColumn
                    dataField="idUser"
                    hidden
                    hiddenOnInsert
                    isKey={true}
                    autoValue={true}
                  >
                    User ID
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    filter={{ type: "TextFilter", delay: 1000 }}
                    headerTitle="Login Name"
                    dataField="loginName"
                  >
                    User
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    filter={{ type: "TextFilter", delay: 1000 }}
                    dataField="name"
                    hiddenOnInsert
                  >
                    Name
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    dataField="idUserProfile"
                    customInsertEditor={{
                      getElement: (column, attr, className, ignoreEditable, defaultValue) =>
                        customInsertEditor(column, attr, className, ignoreEditable, defaultValue, userProfiles),
                    }}
                  >
                    User Profile
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    dataField="idDepartment"
                    customInsertEditor={{
                      getElement: (column, attr, className, ignoreEditable, defaultValue) =>
                        customInsertEditor(column, attr, className, ignoreEditable, defaultValue, departments),
                    }}
                  >
                    Department
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    dataField="idLanguage"
                    customInsertEditor={{
                      getElement: (column, attr, className, ignoreEditable, defaultValue) =>
                        customInsertEditor(column, attr, className, ignoreEditable, defaultValue, languages),
                    }}
                  >
                    Language
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            )}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
}

export default Users;